import React from 'react';
import projectImg1 from '../../assets/images/project/project-page-1-1.jpg';
import projectImg2 from '../../assets/images/project/project-page-1-2.jpg';
import projectImg3 from '../../assets/images/project/project-page-1-3.jpg';
import projectImg4 from '../../assets/images/project/project-page-1-4.jpg';


const ProjectMain = () => {
    // Example team member data

    return (
        <React.Fragment>
           <section className="project-page">
            <div className="container">
                <div className="row masonary-layout">
                    <div className="col-xl-6">
                        <div className="project-page__single">
                            <div className="project-page__img">
                                <img src={projectImg1} alt="/" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="project-page__single">
                            <div className="project-page__img">
                                <img src={projectImg2} alt="/" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="project-page__single">
                            <div className="project-page__img">
                                <img src={projectImg3} alt="/" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="project-page__single">
                            <div className="project-page__img">
                            <div className="project-page__img">
                                <img src={projectImg4} alt="/" />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
        </React.Fragment>
    );
};

export default ProjectMain;
